import React from "react";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import PageOptions from "../PageOptions/PageOptions";
import { CustomPaginationContainer } from "./CustomPaginationContainer";
import useResponsive from "../../../hooks/useResponsive";
import { SelectChangeEvent } from "@mui/material";

interface PaginationInfo {
  pages: number;
  page: number;
  total: number;
}

interface CustomPaginationProps {
  paginationInfo: PaginationInfo;
  handlePageChange: (event: React.ChangeEvent<unknown>, page: number) => void;
  pageOption: string;
  handleChangePageOption: (event: SelectChangeEvent<number>, child: React.ReactNode) => void;
}

const CustomPagination: React.FC<CustomPaginationProps> = ({
  paginationInfo,
  handlePageChange,
  pageOption,
  handleChangePageOption,
}) => {
  const isMobile = useResponsive();

  return (
    <CustomPaginationContainer>
      <Stack spacing={2}>
        <div className="pagination-container">
          <div className="dataTables_info" style={{ marginRight: "auto" }}>
            Showing {paginationInfo?.page * Number(pageOption) + 1} to{" "}
            {Math.min(
              (paginationInfo?.page + 1) * Number(pageOption),
              paginationInfo?.total
            )}{" "}
            of {paginationInfo?.total} entries
          </div>
          <div className="page-options-container">
            <span>Rows Per Page:</span>
            &ensp;
            <PageOptions
              pageOption={pageOption}
              handleChangePageOption={handleChangePageOption}
            />
          </div>
          <Pagination
            className="pagination-btn"
            size={isMobile ? "small" : undefined}
            count={paginationInfo?.pages}
            page={paginationInfo?.page + 1}
            onChange={handlePageChange}
            color="primary"
            style={{ marginRight: "450px" }}
          />
        </div>
      </Stack>
    </CustomPaginationContainer>
  );
};

export default CustomPagination;
